import { interpolate } from 'remotion';

// Types
import type { CameraContainerProps } from '../../types';

// Constants
import { CAMERA_CONFIG } from '../../constants';

export const CameraContainer = ({
  children,
  cameraProgress,
}: CameraContainerProps) => {
  // Calculate transform values based on camera progress
  const cameraScale = interpolate(
    cameraProgress,
    [0, 1],
    [CAMERA_CONFIG.scale.start, CAMERA_CONFIG.scale.end],
  );

  const cameraRotateX = interpolate(
    cameraProgress,
    [0, 1],
    [CAMERA_CONFIG.rotateX.start, CAMERA_CONFIG.rotateX.end],
  );

  const cameraRotateY = interpolate(
    cameraProgress,
    [0, 1],
    [CAMERA_CONFIG.rotateY.start, CAMERA_CONFIG.rotateY.end],
  );

  return (
    <div
      className="size-full"
      style={{
        transform: `perspective(${CAMERA_CONFIG.perspectivePx}px) scale(${cameraScale}) rotateX(${cameraRotateX}deg) rotateY(${cameraRotateY}deg)`,
        transformOrigin: 'center center',
      }}
    >
      {children}
    </div>
  );
};
